import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

export interface ContentSectionProps {
  sideNavShow: boolean;
}

const ContentSection: React.FC<ContentSectionProps> = ({ sideNavShow }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "auto",
      });
    }
  }, [location.pathname]);

  return (
    <div
      ref={containerRef}
      className="bg-background flex-1 flex flex-col items-center w-full overflow-auto overflow-x-hidden"
    >
      <Outlet />
    </div>
  );
};

export default ContentSection;
